{
  "version": 1,
  "asset_id": "089cc81d-dd1d-4fe4-b17b-2cb8de6ba759",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/089cc81d-dd1d-4fe4-b17b-2cb8de6ba759/hero-new-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/089cc81d-dd1d-4fe4-b17b-2cb8de6ba759/hero-new-1280.avif",
  "original_filename": "hero-new-1280.avif",
  "size": 62458,
  "content_type": "image/avif",
  "created_at": "2026-07-25T03:21:13Z"
}
